import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';
import { forwardRef, useRef } from 'react';
import { LuCheck } from 'react-icons/lu';

import { createSyntheticChangeEvent } from '../../../utils';
import { CheckboxDefaultProps, type CheckboxProps } from './Checkbox.types';

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, checked, onChange, ...props }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleCheckedChange = (event: { checked: boolean | 'indeterminate' }) => {
      if (onChange) {
        const isChecked = !!event.checked;
        const syntheticEvent = createSyntheticChangeEvent(
          inputRef.current,
          String(isChecked),
          isChecked
        );
        onChange(syntheticEvent);
      }
    };

    return (
      <ChakraCheckbox.Root
        checked={checked}
        onCheckedChange={handleCheckedChange}
        cursor={props.disabled ? 'default' : 'pointer'}
        {...props}
      >
        <ChakraCheckbox.HiddenInput ref={ref ?? inputRef} />
        <ChakraCheckbox.Control
          // 'bg' (not a literal white) so an unchecked box reads as a neutral
          // surface in dark mode instead of a stray white square.
          bg={{ base: 'bg', _checked: 'colorPalette.solid' }}
          borderWidth="1px"
          borderStyle="solid"
          borderColor={{ base: 'border', _checked: 'colorPalette.solid' }}
          cursor={props.disabled ? 'default' : 'pointer'}
        >
          <ChakraCheckbox.Indicator>
            <LuCheck strokeWidth={3} />
          </ChakraCheckbox.Indicator>
        </ChakraCheckbox.Control>
        {label && <ChakraCheckbox.Label>{label}</ChakraCheckbox.Label>}
      </ChakraCheckbox.Root>
    );
  }
);

Checkbox.displayName = 'Checkbox';
Checkbox.defaultProps = CheckboxDefaultProps;

export { Checkbox };
